var mockData1 = {
  className: 'example',
  totalPages: 2,
  currentPage: 1,
  toUrl: '/blog/'
};
var mockData2 = {
  className: 'example',
  totalPages: 5,
  currentPage: 2,
  toUrl: '/blog/'
};
var mockData3 = {
  className: 'example',
  totalPages: 5,
  currentPage: 3,
  toUrl: '/blog/'
};
var mockData4 = {
  className: 'example',
  totalPages: 5,
  currentPage: 4,
  toUrl: '/blog/',
  omitSeq: true
};
var mockData5 = {
  className: 'example',
  totalPages: 5,
  currentPage: 5,
  toUrl: '/blog/'
};
var mockDataRouteArray = {
  className: 'example',
  totalPages: 5,
  currentPage: 3,
  pageRoute: ['path', 'to', 'page']
};
export { mockData1, mockData2, mockData3, mockData4, mockData5, mockDataRouteArray };